import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { useDate } from "../../../hooks/useDate";

export default function HumedadConcentradoAlimentado() {
  // Objecto default del state
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  const [concentradoAlim, setConcentradoAlim] = useState(defaultObject);
  const [limiteHumedad, setLimiteHumedad] = useState(defaultObject);

  // Peticion inicial de esta grafica
  const initialFetch = new TostadorFetching()
    .setIdSeccion(8)
    .setSecuencia(1)
    .setFrecuencia(720)
    .setDias(7);

      // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  useEffect(() => {
    async function fetchData() {
      const { data } = await getValoresPeriodo(initialFetch);
      populateConcentradoAlim(data);
      populateLimiteHumedad(data);
      setDateHook(data, "Conc_Alim_Humedad");

      setTimeout(() => {
        fetchData();
      }, 300000);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateConcentradoAlim(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Conc_Alim_Humedad"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setConcentradoAlim({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateLimiteHumedad(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "H2O_CONC.LIMIT"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLimiteHumedad({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            title="Humedad Concentrado Alimentado - Reporte"
            subtitle={"Periodo " + fullDate()}
            zoom="x"
          >
            <Chart.Column
              name="%H2O Concentrado Alimentado - Reporte"
              data={concentradoAlim.value}
              yAxis={0}
            />
            <Chart.Line
              name="Limite Humedad Concentrado"
              data={limiteHumedad.value}
              yAxis={0}
            />

            <Chart.XAxis
              allowDecimals={false}
              categories={concentradoAlim.fecha}
            />
            <Chart.YAxis
              labelSuffix=" °%"
              title="Contenido, %"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis labelSuffix=" %" />
            <Chart.Tooltip valueSuffix=" %" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
